import {
  aThreatIntelItem,
  aThreatIntelItemPage,
  mockThreatIntelItemsOperationQuery,
} from '__generated__';

export const getThreatIntelSourceItemsOperationQuery = ({
  value,
  description,
  intelItemsCount = 0,
}) => {
  return mockThreatIntelItemsOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(500), // mock loading state
      ctx.data({
        __typename: 'Query',
        threatIntelItems: aThreatIntelItemPage({
          hasNextPage: false,
          total: intelItemsCount,
          objects:
            intelItemsCount === 0
              ? []
              : [
                  aThreatIntelItem({
                    id: 'eae639a700063eff884a39363c977e243a08ee3',
                    value: value,
                    meta: {
                      description: description,
                      __typename: 'ItemMeta',
                    },
                  }),
                ],
        }),
      })
    );
  });
};

export const handlers = [
  mockThreatIntelItemsOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        threatIntelItems: aThreatIntelItemPage(),
      })
    );
  }),
];
